import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Format a number as currency with 2 decimal places
 * @param {number|string} value - The value to format
 * @param {string} currency - Currency symbol (default: '$')
 * @returns {string} Formatted currency string
 */
export function formatCurrency(value, currency = '$') {
  const numValue = parseFloat(value);
  if (isNaN(numValue)) return `${currency}0.00`;
  return `${currency}${numValue.toFixed(2)}`;
}
